import React from "react";
import { Link } from "react-router-dom";
import { SITELINK_PAGES } from "../../../constants/seo";
import "./HomeBrowseJobs.css";

const CARD_COPY = {
  "/post-job": "Hire CA, CS, and CMA talent in days.",
  "/ca-jobs": "Latest Chartered Accountant openings.",
  "/cs-jobs": "Company Secretary and compliance roles.",
  "/cma-jobs": "CMA and cost accounting jobs.",
  "/featured-job": "Premium roles managed for clients.",
  "/career-sites": "PSU and company career-site jobs.",
};

const HomeBrowseJobs = () => (
  <section className="home-browse-jobs" aria-labelledby="home-browse-jobs-title">
    <div className="home-browse-jobs-container">
      <div className="home-browse-jobs-header">
        <h2 id="home-browse-jobs-title">Browse jobs by category</h2>
        <p>Explore the most searched job categories for CA, CS, and CMA professionals.</p>
      </div>
      <div className="home-browse-jobs-grid">
        {SITELINK_PAGES.map((item) => (
          <Link key={item.path} to={item.path} className="home-browse-jobs-card">
            <span className="home-browse-jobs-card-title">{item.label}</span>
            <span className="home-browse-jobs-card-copy">
              {CARD_COPY[item.path] || "Explore openings on CAJobPortal."}
            </span>
            <span className="home-browse-jobs-card-cta">View openings</span>
          </Link>
        ))}
      </div>
    </div>
  </section>
);

export default HomeBrowseJobs;
